import * as React from "react";
import { forwardRef } from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgIconMail16 = (props, ref) => /* @__PURE__ */ _jsx("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 16,
	height: 16,
	fill: "none",
	viewBox: "0 0 16 16",
	ref,
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fill: "currentColor",
		fillRule: "evenodd",
		d: "M13.5 13h-11A1.5 1.5 0 0 1 1 11.5v-7A1.5 1.5 0 0 1 2.5 3h11A1.5 1.5 0 0 1 15 4.5v7a1.5 1.5 0 0 1-1.5 1.5m-.56-1.5-2.744-2.743L8 10.447l-2.196-1.69L3.06 11.5zm.56-1.56V6.214l-2.105 1.62zm-11-3.725V9.94l2.105-2.104zM2.73 4.5 8 8.554 13.27 4.5z",
		clipRule: "evenodd"
	})
});
const ForwardRef = forwardRef(SvgIconMail16);
export default ForwardRef;
